export default "<p>dispatchitem works!</p>\n";